import PageModule from "@insite/client-framework/Types/PageModule";
import ContentPage from "@insite/content-library/Pages/Page";

const fieldDefinitions = ContentPage.definition.fieldDefinitions ? [...ContentPage.definition.fieldDefinitions] : [];

const pageModule: PageModule = {
    component: ContentPage.component,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions,
    },
};

export default pageModule;
